import React, { useState } from 'react';
import { Card, Button, Row, Col } from 'react-bootstrap';
import imageService from '../../service/ImageServie';

function AdCard({ advertisement, onViewDetails }) {

    const [showNumber, setShowNumber] = useState(false);

    const formatPhoneNumber = (phoneNumber) => {
        // Format phone number as (XXX) XXX-XXXX
        return phoneNumber.replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3');
      };

      const handlePhoneClick = (phone) => {
        if (showNumber) {
           // Initiate a call (this will only work if your environment supports such functionality)
          window.location.href = `tel:${phone}`; }
        else {
          // Make the phone number visible
          setShowNumber(true);
        }
      };

    return (<>
        <Card className="mb-3 internal_ads_row col-md-11 px-0 shadow border-0">
            <Row className='mx-0 justify-content-center'>
            {advertisement.imageName && (
                <Col md={3} className='p-0 align-content-around ad_banner'>
                <Card.Img variant="top"
                    src={`${imageService.getAdsImage}${advertisement.imageName}`}
                    alt={advertisement.companyName}
                    />
                </Col>
            )}
                <Col md={advertisement.imageName ? 9 : 12}>

                    <Card.Body className='p-0 planCard-style text-left'>
                          <Row>
                            <Col md={12} className='planInfo-style'>
                              <div className='row'>
                                <div className='col-md-5'>
                                  <div className='cardText'>
                                    <span className='ad_miles mb-0'>{advertisement.distance.toFixed(1)} miles</span>
                                    <Card.Title style={{ cursor: "pointer"}} onClick={() => onViewDetails(advertisement.id, advertisement.companyName)}>
                                      {advertisement.companyName}
                                    </Card.Title>

                                    <p className='ad_address mb-0'><i className="fas fa-location-dot" title="location"></i> {advertisement.address  || `${advertisement.city}, ${advertisement.state}`}</p>

                                    {/*<p className='ad_email mb-0'><i className="fa fa-envelope" title="email"></i> {advertisement.email  || 'Not Available'}</p>
                                    <p className='ad_website mb-0'><i className="fa fa-globe" title="website"></i>
                                      <a href={advertisement.website} rel="noopener noreferrer"> {advertisement.website || 'Not Available'}</a>
                                    </p>*/}

                                    {/* {advertisement.website && (
                                      <p className='ad_website mb-2'>
                                        <i className="fa fa-globe" title="website"></i>
                                        <a href={advertisement.website} target="_blank" rel="noopener noreferrer">
                                          {advertisement.website.replace(/https?:\/\/|www\.|\/+/g, ' ')}
                                        </a>
                                      </p>
                                    )}  */}

                                  </div>

                                  <div className='cardText d-md-flex gap-3'>
                                     <p className='ad_email mb-0'><i className="fa fa-envelope" title="email"></i> {advertisement.email  || 'Not Available'}</p>
                                    <p className='ad_website mb-0'><i className="fa fa-globe" title="website"></i>
                                      <a href={advertisement.website} rel="noopener noreferrer"> {advertisement.website || 'Not Available'}</a>
                                    </p>
                                  </div>



                                  {/* <div className="ad_description">
                                    <p className='mb-0'>{advertisement.description}</p>
                                  </div> */}

                                </div>

                                <div className='col-md-7'>
                                  <div className='ad_services'>
                                    <h6 className='ad_worktype'>Work Type : <b>{advertisement.shopType || 'Not Available'}</b></h6>
                                    <ul className='ad_serviceList'>
                                    {advertisement.services.slice(0, 4).map((service, index) => (
                                      <li key={index}>{service}</li>
                                    ))}
                                    </ul>
                                  </div>
                                </div>

                                <div className='col-md-12'>
                                <div className="ad_description">
                                  <p className='mb-0'>
                                     {advertisement.description?.length > 75
                                      ? <>
                                          {advertisement.description.slice(0, 75)}...
                                          <span
                                            className="read-more-link"
                                            onClick={() => onViewDetails(advertisement.id, advertisement.companyName)}
                                          > Read more</span>
                                        </>
                                      : advertisement.description
                                    }
                                  </p>
                                </div>
                                </div>

                                {advertisement.planId === 3 &&(
                                <div className='col-md-12'>
                                    <div className='special_ad_shimmer'>
                                    <h6 className='blink_me'>
                                      {/*<span className='sale_animation'>Highlights :</span> */}
                                     { advertisement.highlight || 'Get in touch for special discount...'}</h6>
                                    </div>
                                </div>
                                )}

                              </div>
                            </Col>

                            <Col md={12} className='p-0'>
                                <div className="planPrice-style text-center justify-content-end d-md-flex gap-2 align-items-center border-top">
                                {/*<h4>For More Details </h4> */}
                                <div className='int_list_phone'>
                                  {/*<button className='btn showNumber' type="button" onClick={()=>handlePhoneClick(advertisement.phone)}>
                                  <i className="fa fa-phone" title="phone"></i> {showNumber ? formatPhoneNumber(advertisement.phone) : "Call Us"}
                                  </button>*/}
                                  <a href={`tel:${advertisement.phone}`} className="btn showNumber">
                                    <i className="fa fa-phone"></i> {formatPhoneNumber(advertisement.phone)}
                                  </a>
                                </div>

                                <div className='int_list_24'>
                                  <h6 className='ad_hours'><i className="far fa-clock" title="time"></i> {advertisement.workingHours}</h6>
                                </div>

                                <div className='int_list_view'>
                                  <Button className='planBtn' variant="primary" onClick={() => onViewDetails(advertisement.id, advertisement.companyName)}>View Detail</Button>
                                </div>

                                </div>
                            </Col>


                          </Row>
                        </Card.Body>
                </Col>



            </Row>
        </Card>

    </>

    );
}

export default AdCard;